import { useApiStore } from "@/stores/api/index.ts";
import getDefaultOpts from "@/store/utils/getDefaultOpts.js";

const fetchUsers = async (module, payload = {}) => {
  const api = useApiStore();
  const { rootState, dispatch } = module;
  const opts = payload.opts ?? {};
  const config = Object.assign(
    getDefaultOpts(),
    {
      isCms: false,
      isAuth: false,
    },
    opts
  );
  let { users } = rootState.Settings;
  if (!users) {
    const { data } = await dispatch("httpRequest", {
      func: api.fetchUsers(),
      config,
    });
    users = {};
    data.forEach((item) => {
      const newItem = { ...item };
      if (!item.categories) {
        newItem.categories = [];
      }
      users[item.auth0ID] = newItem;
    });
    dispatch(
      "setSettingsVar",
      {
        key: "users",
        value: users,
      },
      { root: true }
    );
    dispatch(
      "setSettingsVar",
      {
        key: "loading",
        value: false,
      },
      { root: true }
    );
  }
};

export { fetchUsers };
